import AI from "../page/AI";

const AISection = () => {
    return (
        <section
            id="ai-companion"
            data-section
            data-title="Ai-Companion"
            aria-label="AI Companion"
            className="relative w-full min-h-screen"
        >
            <AI />
        </section>
    );
};

export default AISection;
